import React, { Component } from 'react';
import { connect } from "react-redux";
import './camera_with_framing_single.css';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { setImage, setShowError, setErrorType, setData, setMessageModalVisibility, setLoader } from '../../redux/actionCreators';
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';
import { validateImageQuality } from '@autofact-lib/autofact-lib-check-image-quality';
import config from '../../config/config';
import CameraButton from '../../components/buttons/camera_button/CameraButton';
import imageProcess from '../../library/ImageProcess'
import DialogModal from '../../components/dialog_modal/DialogModal';
import { ReactComponent as IconCheck } from '../../resources/images/check-v2.svg';
import { ReactComponent as IconWarning } from '../../resources/images/warning-circle.svg';

import TitleComponent from '../../components/title/TitleComponent';

const NEW_CARD_TYPE = 'CHL3';

class CameraFramingSingle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            facingMode: props.stepInfo.defaultCamera || 'environment',
            capturedImage: null,
            stream: null,
            isAppleDevice: /iPhone|iPad|iPod/i.test(navigator.userAgent),
            focusDistance: 0,
            focusMode: [],
            minFocus: 0,
            maxFocus: 100,
            iconColor: 'white',
            withLimitedRetry: props.stepInfo.withLimitedRetry || false,
            retries: 0,
            showModal: false,
            modalType: "init", // Se inicia con "init"
            debugMode: ['true', true, "TRUE"].includes(config.debugMode) ? true : false,
            supportManualFocusControl: false,
            supportsFocusControl: false,
            supportsDistanceFocus: false,
            isResolutionIphoneSE: false,
        };
        this.videoRef = React.createRef();
        this.captureImage = this.captureImage.bind(this);
        this.retry = this.retry.bind(this);
        this.toggleCamera = this.toggleCamera.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.validateImageQuality = props.stepInfo.validateImageQuality || false;
        this.closeMessageModal = this.closeMessageModal.bind(this);
        this.getRegions = this.getRegions.bind(this);
        this.getModalMessage = this.getModalMessage.bind(this);
        this.getRegionsFromConfig = this.getRegionsFromConfig.bind(this);
    }

    writeLog = (debugMode, ...log) => {
        if (debugMode) {
            console.log(...log);
        }
    };

    componentDidMount() {
        this.startCamera();
        window.scrollTo(0, document.body.scrollHeight);
        if (this.props.stepInfo.referenceImagesCi !== 'back') {
            this.setState({ showModal: true, modalType: "init" });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.image && this.props.image !== prevProps.image) {
            this.setState({ capturedImage: this.props.image });
        }
    }

    getModalMessage(type) {
        const messages = {
            retry: {
                title: "La imagen capturada quedó borrosa",
                principalMessage: "Para completar tu transferencia sin inconvenientes, sigue estos consejos:",
                secondaryMessage: [
                    'Asegúrate de un buen encuadre, sin cortar los bordes del carnet.',
                    'Verifica que haya buena iluminación para mayor claridad.',
                    'La imagen debe estar nítida y legible, sin reflejos ni desenfoques.',
                    'Tienes ' + this.getAttempts() + ' más (máximo ' + config.limitAttemptsQualityCheck + ').',
                ],
                buttons:
                    <MainButton
                        onClick={this.closeMessageModal}
                        text="Reintentar"
                        class={"blue-button"}
                    />,
                type: "warning",
                classModal: "landscape-modal"
            },
            init: {
                title: "Consejos antes de comenzar",
                principalMessage: "Sigue estos consejos para evitar problemas en tu transferencia:",
                secondaryMessage: [
                    'Usa tu teléfono en posición horizontal para las capturas fotográficas.',
                    'Asegúrate de un buen encuadre, sin cortar los bordes del carnet de identidad.',
                    'Verifica que haya buena iluminación para mayor claridad.',
                    'La imagen debe estar nítida y legible, sin reflejos ni desenfoques.',

                ],
                buttons: <MainButton
                    onClick={this.closeMessageModal}
                    text="Entendido, continuar"
                    class="blue-button"
                />,
                type: "camera",
            },
        };
        return messages[type] || messages.init;
    }

    getAttempts() {
        const attempt = config.limitAttemptsQualityCheck - this.state.retries;
        const numbers = ["cero intentos", "un intento", "dos intentos", "tres intentos", "cuatro intentos", "cinco intentos", "seis intentos", "siete intentos", "ocho intentos", "nueve intentos", "diez intentos"];
        if (attempt > 10) {
            return attempt + " intentos";
        }
        if (attempt < 1) {
            return numbers[1];
        }
        return numbers[attempt];
    }


    componentWillUnmount() {
        if (this.state.stream) {
            this.state.stream.getTracks().forEach(track => track.stop());
        }
    }

    closeMessageModal() {
        this.setState({ showModal: false });
    }

    isResolutionIphoneSE = () => {
        const userAgent = navigator.userAgent;
        const isIphone = /iPhone/.test(userAgent);
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        this.writeLog(this.state.debugMode, "isIphone", isIphone, "screenWidth", screenWidth, "screenHeight", screenHeight);

        return isIphone && ((screenWidth === 375 && screenHeight === 667) || (screenWidth === 667 && screenHeight === 375));
    };

    async startCamera() {
        try {
            let constraints = {
                video: {
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                    facingMode: this.state.facingMode,
                },
                audio: false
            };
            this.setState({ isResolutionIphoneSE: this.isResolutionIphoneSE() });
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            const [track] = stream.getVideoTracks();
            const capabilities = track.getCapabilities();
            this.setState({ focusMode: capabilities.focusMode });

            if ((capabilities?.focusDistance?.min !== undefined) && capabilities?.focusDistance?.max) {
                this.setState({
                    minFocus: capabilities.focusDistance.min,
                    maxFocus: capabilities.focusDistance.max,
                    supportsDistanceFocus: true
                });
                const distance = capabilities.focusDistance.min;
                this.writeLog(this.state.debugMode, "Capacidades de la cámara:", capabilities);
                if ("focusDistance" in capabilities) {
                    this.setState({ supportsFocusControl: true });
                    if (capabilities.focusMode && capabilities.focusMode.includes("manual")) {
                        await track.applyConstraints({ advanced: [{ focusMode: "manual" }] });
                        await track.applyConstraints({ advanced: [{ focusDistance: distance }] });
                        // Esperar un poco para dar tiempo a que la cámara ajuste el enfoque
                        await new Promise(resolve => setTimeout(resolve, 1000));
                        // Obtener la configuración actual de la cámara
                        const settings = track.getSettings();
                        if (settings.focusDistance) {
                            this.writeLog(this.state.debugMode, `✅ focusDistance establecido en:`, settings.focusDistance, 'configuración de la cámara', settings);
                        } else {
                            this.writeLog(this.state.debugMode, "⚠️ No se pudo confirmar el valor de focusDistance.");
                        }
                        this.setState({ focusDistance: settings.focusDistance, supportManualFocusControl: true });
                    } else {
                        this.writeLog(this.state.debugMode, "La cámara no admite control de enfoque manual.");

                    }
                } else {
                    this.writeLog(this.state.debugMode, "La cámara no admite control de enfoque.");
                }
            } else {
                this.writeLog(this.state.debugMode, "La cámara no admite enfoque a distancia.");
            }

            this.videoRef.current.srcObject = stream;
            this.setState({ stream });
        } catch (error) {
            console.error("Error al acceder a la cámara:", error);
        }
    }

    handleFocusChange(event) {
        const newFocus = parseFloat(event.target.value).toFixed(17);
        this.setState({ focusDistance: newFocus }, async () => {
            if (this.state.stream) {
                const [track] = this.state.stream.getVideoTracks();
                await track.applyConstraints({ advanced: [{ focusDistance: newFocus }] });
                // Esperar un poco para dar tiempo a que la cámara ajuste el enfoque
                await new Promise(resolve => setTimeout(resolve, 1000));
                const settings = track.getSettings();
                if (settings.focusDistance) {
                    this.writeLog(this.state.debugMode, `✅ focusDistance true establecido en:`, settings.focusDistance, 'configuración de la cámara', settings);
                    this.setState({ focusDistance: settings.focusDistance });
                } else {
                    this.writeLog(this.state.debugMode, "⚠️ No se pudo confirmar el valor de focusDistance.");
                }
            }
        });
    }

    captureImage() {
        const video = this.videoRef.current;
        const canvas = this.createCanvas(video);
        const imageSrc = canvas.toDataURL('image/png');
        const img = new Image();
        img.src = imageSrc;

        img.onload = async () => {
            const qualityResult = await this.checkImageQuality(img, canvas);
            const isValidQuality = this.evaluateQuality(qualityResult);

            if (!isValidQuality && this.shouldRetry()) {
                this.retryCapture();
                return;
            }

            this.storeCapturedImage(imageSrc, qualityResult);
            this.sendImageData(qualityResult);
        };
    }

    createCanvas(video) {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        return canvas;
    }

    async checkImageQuality(img, canvas) {
        const regions = this.getRegions(canvas);
        const qualityResult = await validateImageQuality(img, {
            customRegions: regions,
            customThresholds: config.customThresholds,
            customScaleValue: { maxWidth: 1280, maxHeight: 720 },
            debugMode: this.state.debugMode,
        });

        this.writeLog(this.state.debugMode, 'qualityResult', qualityResult);

        return qualityResult;
    }

    evaluateQuality(qualityResult) {
        if (!this.validateImageQuality) return true;

        const { brightness, sharpness, readableQrCode } = qualityResult;
        const isBackImage = this.props.stepInfo.referenceImagesCi === 'back';
        const qrValidationEnabled = ['true', true, "TRUE"].includes(config.qRValidationEnabled);

        return brightness && sharpness && (readableQrCode || !(isBackImage && qrValidationEnabled));
    }

    shouldRetry() {
        return this.state.withLimitedRetry && this.state.retries <= config.limitAttemptsQualityCheck;
    }

    retryCapture() {
        this.setState(prevState => ({
            showModal: true,
            modalType: "retry",
            retries: prevState.retries + 1
        }));
    }

    storeCapturedImage(imageSrc, qualityResult) {
        const processedImage = this.state.debugMode ? qualityResult.processedImage : imageSrc;
        const dataUrl = qualityResult.processedImage;
        const width = 200;
        const height = 100;
        this.writeLog(this.state.debugMode,
            '%c ',
            `
                font-size: ${height}px;
                padding: ${height / 2}px ${width / 2}px;
                background: url(${dataUrl}) no-repeat center center;
                background-size: contain;
            `
        );
        // this.setState({ capturedImage: processedImage });
        this.props.setImage(processedImage);
    }

    sendImageData(qualityResult) {
        const {
            isAppleDevice,
            withLimitedRetry,
            supportsDistanceFocus,
            focusDistance,
            supportManualFocusControl,
            supportsFocusControl,
            retries,
            focusMode,
            minFocus,
            maxFocus,
            isResolutionIphoneSE,
        } = this.state;

        const { brightness, contrast, readableQrCode, qrCodeContent, scores } = qualityResult;

        const data = {
            isAppleDevice,
            validateImageQuality: this.validateImageQuality,
            withLimitedRetry,
            retries,
            brightness,
            contrast,
            readableQrCode,
            qrCodeContent,
            scores,
            supportsDistanceFocus,
            focusDistance,
            supportManualFocusControl,
            supportsFocusControl,
            focusMode: focusMode ? focusMode.join(', ') : [],
            minFocus,
            maxFocus,
            CameraFramingSingle: true,
            isResolutionIphoneSE,
        };

        this.props.setData(data);
    }

    getRegions(canvas) {
        if (config.regions) {
            const regions = this.getRegionsFromConfig(canvas);
            if (regions) {
                return regions;
            }
        }
        if (this.props.stepInfo.referenceImagesCi == 'back') {
            if (window.screen.orientation.type === 'landscape-primary' || window.matchMedia('(orientation:landscape)').matches) {
                return {
                    center: {
                        startX: Math.floor(canvas.width * 0.22),
                        startY: Math.floor(canvas.height * 0.62),
                        width: Math.floor(canvas.width * 0.65),
                        height: Math.floor(canvas.height * 0.20),
                    },
                };
            }
            return {
                center: {
                    startX: Math.floor(canvas.width * 0.06),
                    startY: Math.floor(canvas.height * 0.12),
                    width: Math.floor(canvas.width * 0.14),
                    height: Math.floor(canvas.height * 0.4),
                },
            };
        }
        if (window.screen.orientation.type === 'landscape-primary' || window.matchMedia('(orientation:landscape)').matches) {
            return {
                center: {
                    startX: Math.floor(canvas.width * 0.25),
                    startY: Math.floor(canvas.height * 0.35),
                    width: Math.floor(canvas.width * 0.35),
                    height: Math.floor(canvas.height * 0.3),
                },
            };
        }
        return {
            center: {
                startX: Math.floor(canvas.width * 0.20),
                startY: Math.floor(canvas.height * 0.15),
                width: Math.floor(canvas.width * 0.18),
                height: Math.floor(canvas.height * 0.18),
            },
        };
    }

    getRegionsFromConfig(canvas) {
        const regions = JSON.parse(config.regions);
        const screenOrientation = (window.screen.orientation.type === 'landscape-primary' || window.matchMedia('(orientation:landscape)').matches) ? 'landscape' : 'portrait';
        this.writeLog(this.state.debugMode, 'referenceImagesCi', this.props.stepInfo.referenceImagesCi);
        this.writeLog(this.state.debugMode, 'orientation', screenOrientation);
        this.writeLog(this.state.debugMode, 'regionsJson', regions);
        for (const side in regions) {
            if (side === this.props.stepInfo.referenceImagesCi) {
                for (const orientation in regions[side]) {
                    if (orientation !== screenOrientation) {
                        this.writeLog(this.state.debugMode, `Skipping region for ${side} in ${orientation} orientation`);
                        continue;
                    }
                    const center = regions[side][orientation].center;
                    this.writeLog(this.state.debugMode, `Side: ${side}, Orientation: ${orientation}`);
                    return {
                        center: {
                            startX: Math.floor(canvas.width * center.startX),
                            startY: Math.floor(canvas.height * center.startY),
                            width: Math.floor(canvas.width * center.width),
                            height: Math.floor(canvas.height * center.height),
                        }
                    };
                }
            } else {
                this.writeLog(this.state.debugMode, `Skipping region for ${side}`);
            }
        }
        return null;
    }

    toggleCamera() {
        this.setState(
            prevState => ({ facingMode: prevState.facingMode === 'user' ? 'environment' : 'user' }),
            this.startCamera
        );
    }

    retry() {
        this.setState({ capturedImage: null });
        this.startCamera();
    }
    getFraming(icon) {
        if (icon === 'ci-back.svg' && this.props.stepInfo.cardType === NEW_CARD_TYPE) {
            icon = 'ci-back-new.svg';
        }
        return this.props.stepInfo.icon ? require(`../../resources/images/${icon}`).default : undefined;
    }

    launchCamera = (inputFile) => {
        const {
            isAppleDevice,
            withLimitedRetry,
            supportsDistanceFocus,
            focusDistance,
            supportManualFocusControl,
            supportsFocusControl,
            retries,
            focusMode,
            minFocus,
            maxFocus,
            isResolutionIphoneSE,
        } = this.state;
        const data = {
            isAppleDevice,
            withLimitedRetry,
            retries,
            supportsDistanceFocus,
            focusDistance,
            supportManualFocusControl,
            supportsFocusControl,
            focusMode: focusMode ? focusMode.join(', ') : [],
            minFocus,
            maxFocus,
            CameraFramingSingle: false,
            isResolutionIphoneSE
        };
        this.props.setData(data)
        inputFile.click();
        this.props.setLoader(true);
    };

    getImage = async (event, inputFile) => {
        this.props.setLoader(true);
        try {
            const image = await imageProcess.getImageFromFileInput(event, inputFile);
            this.props.setImage(image);
            this.props.setShowError(false);
            this.props.nextStep();
        } catch (error) {
            this.props.setErrorType('defaultImage');
        }
        this.closeMessageModal();
    };

    renderMessage = (message, className = '') => {
        if (!message) return null;

        if (Array.isArray(message)) {
            return message.map((msg, index) => (
                <div key={index} className={className}>
                    <div className="container-tips">
                        <div className="icon">
                            <IconCheck />
                        </div>
                        <div className="text">
                            {msg}
                        </div>
                    </div>
                </div>
            ));
        }

        if (typeof message === 'object') {
            return <div className={className}>{JSON.stringify(message)}</div>;
        }

        return <div className={className}>{message}</div>;
    };

    render() {
        const ToggleCameraIcon = require('../../resources/images/Switch.svg').default;
        return (
            <div>
                {this.state.capturedImage ? (
                    <div className='preview'>
                        
                <PageWithFooter
                    footer={(
                        <FooterContainer>
                                <Col xs={6}>
                                    <CameraButton
                                        text="Repetir"
                                        getImage={this.getImage}
                                        launchCamera={this.launchCamera}
                                        ref={cameraButton => this.cameraButton = cameraButton}
                                        outline={true}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <MainButton onClick={this.props.nextStep} className='next-button'>Continuar</MainButton>
                                </Col>
                            </FooterContainer>
                    )}
                >
                <Grid>
                            <Row>
                                <Col xs={12} className='content-image'>
                                    <p className='content-description'>Revisa la imagen; si no es clara, inténtalo de nuevo.</p>
                                    <img src={this.state.capturedImage} alt="Captured" />
                                </Col>
                            </Row>
                        </Grid>
                </PageWithFooter>
                    </div>
                ) : (this.state.retries < config.limitAttemptsQualityCheck ?
                    <div className="camera-with-framing-single">
                        <video
                            ref={this.videoRef}
                            autoPlay
                            playsInline
                            style={{ width: '100%', height: '100%' }}
                        />
                        <div className='camera-framing-single'>
                            <img className='camera-icon-single' src={this.getFraming(this.props.stepInfo.icon)} alt="Icon" />
                        </div>
                        <div className="button-container-single">
                            <Col xs={2}> <Button className='capture-button' onClick={this.captureImage}></Button> </Col>
                            <Col xs={2}>
                                <div onClick={this.toggleCamera}>
                                    <img src={ToggleCameraIcon} alt="Toggle Camera" />
                                </div>
                            </Col>
                        </div>
                        {this.state.showModal && (
                            <DialogModal
                                isVisible={this.state.showModal}
                                title={this.getModalMessage(this.state.modalType).title}
                                principalMessage={this.getModalMessage(this.state.modalType).principalMessage}
                                secondaryMessage={this.getModalMessage(this.state.modalType).secondaryMessage}
                                onClose={() => this.setState({ showModal: false })}
                                buttons={this.getModalMessage(this.state.modalType).buttons}
                                type={this.getModalMessage(this.state.modalType).type}
                                classModal={this.getModalMessage(this.state.modalType).classModal}
                            />
                        )}

                    </div>
                    :
                    <div className={'camera-without-frame'}>
                        <Grid>
                            <Row className={'container-content'} key="container-content">
                                <Col xs={12} className={'container-icon'}>
                                    <IconWarning style={{ width: '26px', height: '26px' }} />
                                </Col>
                                <Col xs={12} className={'content'}>
                                    <TitleComponent bolder black className={'text-center'}>{this.getModalMessage(this.state.modalType).title}</TitleComponent>
                                    {this.renderMessage(this.getModalMessage(this.state.modalType).principalMessage)}
                                    {this.renderMessage(this.getModalMessage(this.state.modalType).secondaryMessage)}
                                </Col>
                            </Row>
                        </Grid>
                <FooterContainer>
                    <Col xs={12}>
                        <CameraButton
                            text="Reintentar"
                            getImage={this.getImage}
                            launchCamera={this.launchCamera}
                            ref={cameraButton => this.cameraButton = cameraButton}
                        />
                    </Col>
                </FooterContainer>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    component: state.component,
    image: state.image,
    capturedImage: state.capturedImage,
    showError: state.showError,
    setErrorType: state.setErrorType,
    stepInfo: state.stepInfo
});

const mapDispatchToProps = dispatch => ({
    setImage: image => dispatch(setImage(image)),
    setShowError: showError => dispatch(setShowError(showError)),
    setErrorType: errorType => dispatch(setErrorType(errorType)),
    setData: data => dispatch(setData(data)),
    setMessageModalVisibility(messageModalVisibility) {
        dispatch(setMessageModalVisibility(messageModalVisibility));
    },
    setLoader(loader) {
        dispatch(setLoader(loader));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CameraFramingSingle);
